import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-between gap-4"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-xs" }
const _hoisted_4 = { class: "py-4" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex items-center gap-4" }
const _hoisted_7 = { class: "text-xs" }

import { ref } from "vue";
import { type PropType } from "vue";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronLeftIcon, ChevronRightIcon, ChevronDownIcon } from "@heroicons/vue/24/outline";

type Rows = "All" | "5 Rows" | "10 Rows" | "20 rows";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimplePagination',
  props: {
	showRows: {
		type: Boolean,
		default: true,
	},
	numRows: {
		type: Number,
		defualt: 5,
	},
	currentPage: {
		type: Number,
		default: 1,
		required: true,
	},
	lastPage: {
		type: Number,
		default: 1,
		required: true,
	},
},
  emits: ["update"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const options = ref<number[]>([5,10,20,50,100,200])

const props = __props;

const pagination = ref<{rows: number, page: number}>({
    rows: props.numRows,
    page: props.currentPage || 1,
})

const nextPage = () => {
	if (props.lastPage === props.currentPage) {
		return false;
    }
    pagination.value.page = pagination.value.page + 1
    
	emit("update", pagination.value);
};

const previousPage = () => {
	if (props.currentPage <= 1) {
		return false;
    }

	pagination.value.page = pagination.value.page - 1
	emit("update", pagination.value);
};

const changeRows = (row: number): void => {
    pagination.value.rows = row;
    pagination.value.page = 1;
    emit("update", pagination.value);
};

return (_ctx: any,_cache: any) => {
  return (__props.lastPage > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Menu), {
          as: "div",
          class: "relative inline-block text-left"
        }, {
          default: _withCtx(() => [
            (__props.showRows)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_unref(MenuButton), { class: "flex items-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, "Rows: " + _toDisplayString(__props.numRows), 1),
                      _createVNode(_unref(ChevronDownIcon), { class: "w-4 h-4 ml-1 cursor-pointer stroke-2 text-neutral-900" })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_Transition, {
              "enter-active-class": "transition duration-100 ease-out",
              "enter-from-class": "transform scale-95 opacity-0",
              "enter-to-class": "transform scale-100 opacity-100",
              "leave-active-class": "transition duration-75 ease-in",
              "leave-from-class": "transform scale-100 opacity-100",
              "leave-to-class": "transform scale-95 opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(MenuItems), { class: "absolute left-0 bottom-8 z-10 w-56 mt-2 origin-bottom-left bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
                        return (_openBlock(), _createBlock(_unref(MenuItem), { key: option }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (changeRows(option)),
                              class: _normalizeClass([
									option == __props.numRows ? 'bg-gray-100 text-neutral-900 font-semibold' : 'text-gray-700',
									'block px-4 py-2 text-sm cursor-pointer',
								])
                            }, _toDisplayString(option) + " Rows", 11, _hoisted_5)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(__props.currentPage > 1 ? '' : 'opacity-25')
          }, [
            _createVNode(_unref(ChevronLeftIcon), {
              class: "w-4 h-4 cursor-pointer stroke-2 text-neutral-900",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (previousPage()))
            })
          ], 2),
          _createElementVNode("span", _hoisted_7, _toDisplayString(__props.currentPage) + " of " + _toDisplayString(__props.lastPage), 1),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(__props.currentPage === __props.lastPage ? 'opacity-25' : '')
          }, [
            _createVNode(_unref(ChevronRightIcon), {
              class: "w-4 h-4 cursor-pointer stroke-2 text-neutral-900",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (nextPage()))
            })
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})